import React from "react";
import Form from "../components/Form.js";

export default function FormPage() {
  return <Form />;
}